import { selectActiveScommessaForQuoteFinali, selectTiltlesQuoteByGroup } from 'features/ippica/selectors';

import { IppicaQuoteAccordion } from '../ippicaQuoteAccordion';
import dynamic from 'next/dynamic';
import { getQuoteCombinate } from 'features/ippica/actions';
import { resetIppicaQuoteCombinate } from 'features/ippica/ippicaSlice';
import { useAppDispatch } from 'lib/centralStore';
import { useState } from 'react';
import { useTypedSelector } from 'lib/centralStore';

export const DynamicIppicaQuoteAccordionContainer = dynamic(() =>
  import('features/ippica/components/ippicaQuote/ippicaQuoteAccordionContainer').then(
    (mod) => mod.IppicaQuoteAccordionContainer
  )
);

export const IppicaQuoteAccordionContainer = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [currentCodiceTipoScommessa, setCurrentCodiceTipoScommessa] = useState<number | null>(null);
  const tipoScommessaList = useTypedSelector(selectActiveScommessaForQuoteFinali(true));
  const titleQuoteList = useTypedSelector(selectTiltlesQuoteByGroup);
  const { isOpen } = useTypedSelector((state) => state.carrello);
  const dispatch = useAppDispatch();
  const handleAccordionToggle = (index: number, codiceTipoScommessa: number) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    dispatch(resetIppicaQuoteCombinate());
    dispatch(getQuoteCombinate({ codiceTipoScommessa }));
  };
  return (
    <>
      {!!tipoScommessaList?.length
        ? tipoScommessaList.map((scommessa, index) => {
            return (
              <IppicaQuoteAccordion
                key={
                  scommessa.codiceProgramma + '_' + scommessa.numeroAvvenimento + '_' + scommessa.codiceTipoScommessa
                }
                index={index}
                activeIndex={activeIndex}
                title={titleQuoteList?.[scommessa.codiceTipoScommessa]}
                codiceTipoScommessa={scommessa.codiceTipoScommessa}
                onToggle={handleAccordionToggle}
                hasMarginRight={!isOpen}
                hasMarginBottom
              />
            );
          })
        : null}
    </>
  );
};
